import { TutorialPanelProps } from '@amzn/awsui-components-react';

import { constants } from '../../common/Localization';

export const TutorialPanelI18nStrings: TutorialPanelProps.I18nStrings = {
    labelsTaskStatus: { 
        pending: constants.TOUR_PENDING, 
        'in-progress': constants.TOUR_IN_PROGRESS,
        success: constants.TOUR_SUCCESS 
    },
    loadingText: constants.TOUR_LOADING,
    tutorialListTitle: constants.TOUR_LIST_TITLE,
    tutorialListDescription: constants.TOUR_LIST_DESCRIPTION,
    tutorialListDownloadLinkText: constants.TOUR_DOWNLOAD_LINK_TEXT, //TODO: how to remove this component for now
    tutorialCompletedText: constants.TOUR_COMPLETED_TEXT,
    labelExitTutorial: constants.TOUR_EXIT_LABEL,
    learnMoreLinkText: constants.TOUR_LEARN_MORE,
    startTutorialButtonText: constants.TOUR_START,
    restartTutorialButtonText: constants.TOUR_RESTART,
    completionScreenTitle: constants.TOUR_COMPLETED,
    feedbackLinkText: constants.TOUR_FEEDBACK,
    dismissTutorialButtonText: constants.TOUR_DISMISS,
    taskTitle: (taskIndex: number, taskTitle: string) => `${constants.TOUR_TASK} ${taskIndex + 1}: ${taskTitle}`,
    stepTitle: (stepIndex: number, stepTitle: string) => `${constants.TOUR_STEP} ${stepIndex + 1}: ${stepTitle}`,
    labelTotalSteps: (totalStepCount: number) => `${constants.TOUR_TOTAL_STEPS} ${totalStepCount}`,
    labelLearnMoreExternalIcon: constants.TOUR_LEARN_MORE_ICON
};

export const OverlayI18nStrings = {
    stepCounterText: (stepIndex: number, totalStepCount: any) => `${constants.TOUR_STEP} ${stepIndex + 1}/${totalStepCount}`,
    taskTitle: (taskIndex: number, taskTitle: any) => `${constants.TOUR_TASK} ${taskIndex + 1}: ${taskTitle}`,
    labelHotspot: (openState: any) => (openState ? constants.TOUR_HIDE_ANNODATION : constants.TOUR_SHOW_ANNOTATION),
    nextButtonText: constants.TOUR_NEXT,
    previousButtonText: constants.TOUR_PREVIOUS,
    finishButtonText: constants.TOUR_FINISH,
    labelDismissAnnotation: constants.TOUR_HIDE_ANNODATION
};
